import {Injectable} from "@angular/core";
import {Ms4CustomerModel, ms4CustomerModelFactory} from "./customer.model";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {Apollo} from "apollo-angular";
import {Observable} from "rxjs/index";
import {CustResellerGqlModel, CustResellerInfoGqlModel} from "../workflow/project/custReseller.gql-model";

export type Ms4CustomerServiceListResponse = {
  rows: Ms4CustomerModel[];
  count: number;
  matchFound?: boolean;
};

@Injectable()
export class CustomerService {
  private url: string = "/api/customer";

  async listMs4Customers(search = "", projectId, searchResellers = false, customerSearchBy = 'name', leadCustomerSearch = false, otherCountriesSearch=false): Promise<Ms4CustomerServiceListResponse> {
    const params = {
      search: search ? `${search}` : "",
      projectId: projectId ? `${projectId}` : "",
      searchResellers: searchResellers ? "true" : "false",
      customerSearchBy: customerSearchBy ? customerSearchBy : 'name',
      leadCustomerSearch: leadCustomerSearch ? "true": "false",
      otherCountriesSearch: otherCountriesSearch ? "true" : "false"
    };

    let returnVal = await this.http.get<Ms4CustomerServiceListResponse>(`${this.url}/list-ms4-customers`, {params})
      .pipe(map(json => ({
        rows: json.rows.map(ms4CustomerModelFactory) || [],
        count: +json.count,
        matchFound: false,
      })))
      .toPromise();

    returnVal.rows = returnVal.rows.filter((it) => it.customerName !== null)
    let searchCanonical = search.trim().toLowerCase();
    returnVal.rows.forEach((it) => {
      const itCanonical = it.customerName.trim().toLowerCase();
      if (searchCanonical === itCanonical) returnVal.matchFound = true;
    });

    returnVal.rows.sort((a, b) => {
      // Exact Match
      if (a.customerName.trim() === search) return -1;
      if (b.customerName.trim() === search) return 1;

      // Exact Match with case insensitivity
      searchCanonical = search.trim().toLowerCase();
      const aCanonical = a.customerName.trim().toLowerCase();
      if (aCanonical === searchCanonical) return -1;
      const bCanonical = b.customerName.trim().toLowerCase();
      if (bCanonical === searchCanonical) return 1;

      // Standard ordering
      if (aCanonical < bCanonical) return -1;
      if (aCanonical > bCanonical) return 1;

      // Order by BP ID
      if (a.bpid < b.bpid) return -1;

      return 1;
    });

    return returnVal;
  }

  getCustomerResellerStatus(projectId): Observable<CustResellerInfoGqlModel> {
    const query = CustResellerGqlModel.query;
    const variables = CustResellerGqlModel.variables(projectId);

    return this.apollo.subscribe({query, variables, fetchPolicy: "no-cache"})
      .pipe(CustResellerInfoGqlModel.mapper);
  }

  constructor(private http: HttpClient, private apollo: Apollo) {}
}
